<template>
  <div class="change-password-container">
    <el-form label-width="100px" @submit.prevent="submitForm">
      <el-form-item label="旧密码" :error="formErrors.oldPassword">
        <el-input v-model="form.oldPassword" show-password />
      </el-form-item>
      <el-form-item label="新密码" :error="formErrors.newPassword">
        <el-input v-model="form.newPassword" show-password />
      </el-form-item>
      <el-form-item label="确认密码" :error="formErrors.confirmPassword">
        <el-input v-model="form.confirmPassword" show-password />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" native-type="submit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { ElMessage } from "element-plus";
import { changePassword } from "@/api/usercenterApi";
import { useAuthStore } from "@/store/authStore";

const authStore = useAuthStore();

const form = ref({
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
});

const formErrors = ref({
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
});

const validateForm = () => {
  let isValid = true;

  // 清空错误提示
  formErrors.value = {
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  };

  if (!form.value.oldPassword.trim()) {
    formErrors.value.oldPassword = "请输入旧密码";
    isValid = false;
  }

  if (!form.value.newPassword.trim()) {
    formErrors.value.newPassword = "请输入新密码";
    isValid = false;
  } else if (form.value.newPassword.length < 6) {
    formErrors.value.newPassword = "新密码至少为6位";
    isValid = false;
  }

  if (form.value.newPassword !== form.value.confirmPassword) {
    formErrors.value.confirmPassword = "两次输入密码不一致";
    isValid = false;
  }

  return isValid;
};

const submitForm = async () => {
  if (!validateForm()) return;

  const token = authStore.token || localStorage.getItem("token");
  if (!token) {
    ElMessage.warning("未检测到登录信息");
    return;
  }

  const result = await changePassword({
    token,
    oldPassword: form.value.oldPassword,
    newPassword: form.value.newPassword,
  });

  if (result.success) {
    ElMessage.success(result.msg);
    form.value = {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    };
  } else {
    ElMessage.error(result.msg);
  }
};
</script>

<style scoped>
.change-password-container {
  max-width: 500px;
  margin: 40px auto;
}
</style>
